import labels from '../../utils/constants/labels';
import ApiValues from '../url/apiurl'
import Networking from '../../utils/api/apiaccess';
var axios = require('axios');

function getFamilyLiquiloans(data) {
    return Networking.PostApi(ApiValues.familyLiquiloansReport, data).then(result => { return result })
        .catch(function (error) {
            return { "status": "F", "message": labels.messages.apierror }
        });
}

export default getFamilyLiquiloans
